import { ChangeDetectionStrategy, Component, ElementRef, inject } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { AppMenuComponent } from './app.menu.component';

@Component({
    selector: 'app-sidebar',
    templateUrl: './app.sidebar.component.html',
    imports: [AppMenuComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppSidebarComponent {
    layoutService = inject(LayoutService);
    el = inject(ElementRef);
}

